import { IconShoppingBag as TablerIconShoppingBag } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconShoppingBag = /*#__PURE__*/ createOutlineIcon(
  TablerIconShoppingBag,
  'IconShoppingBag',
);
